// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__23KHi","errorLogs":"EditorFooter_errorLogs__3I0-_"};